// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"94b83334","213":"65d307cb","453":"63834957","455":"c40419ab"}[chunkId] + ".chunk.js";
};